module.exports = __webpack_public_path__ + "static/media/mute.94c84c14.svg";